export const getNameInitials = (fullName = '') => {
  return fullName.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(name => name[0].toUpperCase()).join('');
};
//# sourceMappingURL=SeatRow.utils.js.map